import {observable} from 'mobx';

// A AuditLogRequest captures all parameters required to request a audit log
// None of the fields of this object does not need to be filled in.
class AuditLogRequest {

  @observable id_customer = null;
  @observable id_user = null;
  @observable entity = null;
  @observable date_from = null;
  @observable date_to = null;

  constructor() {
  }

  get allEntities() {
    return ['MACHINE', 'LOCATION', 'CUSTOMER', 'CONTRACT'];
  }

}

export default AuditLogRequest;



/** WEBPACK FOOTER **
 ** ./src/DataModel/AuditLogRequest.js
 **/